import dayjs from 'dayjs';
import dayjsEn from 'dayjs/locale/en';
import { CustomLocaleData } from '@app/ui';

export const DAYJS_EN_US: ILocale = {
  ...dayjsEn,
  name: 'en-us',
  formats: {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
  },
};

export const US_CUSTOM_LOCALE_DATA: CustomLocaleData = {
  localeIdentifier: 'en-US',
  currencyName: 'USD',
  currencySymbol: '$',
  phoneCountry: 'us',
  hourOnlyFormat: 'h A',
  timeWithLeadingZeroFormat: 'hh:mm A',
  timezone: 'America/Denver',
};

dayjs.locale(DAYJS_EN_US, undefined, true);
